import React from "react";
import Header from "./Header";
import MainScreen from "./Main";

const App = () => {
  return (
    <div className="container">
      <header>
        <Header />
      </header>
      <div className="body">
        <MainScreen />
      </div>
    </div>
  );
};

export default App;
